var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotherHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29376",
    "data-name": "Group 29376",
    transform: "translate(-221 -182.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(221 182.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_3_",
    "data-name": "svgexport-17 (3)",
    transform: "translate(241 187.98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49921",
    "data-name": "Path 49921",
    d: "M99.123,11.81l-.581-.525a1.788,1.788,0,0,1-.588-1.326V3.814A3.814,3.814,0,0,0,94.14,0H91.7a2.063,2.063,0,0,0-1.629.8l-.312.4a1.022,1.022,0,0,1-.807.395,1.338,1.338,0,0,0-1.338,1.338V9.958a1.788,1.788,0,0,1-.588,1.326l-.581.525a1.788,1.788,0,0,0,1.046,3.107c1.321.119,3.966.083,5.292.083s3.971.036,5.292-.083a1.788,1.788,0,0,0,1.046-3.107Z",
    transform: "translate(-85.859 0)",
    fill: "#302d31"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28914",
    "data-name": "Group 28914",
    transform: "translate(4.511)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49922",
    "data-name": "Path 49922",
    d: "M198.062,15c-.375,0-.855,0-1.38,0,.68,0,1.348,0,1.9,0Zm7.373-3.19-.581-.525a1.788,1.788,0,0,1-.589-1.326V3.814A3.814,3.814,0,0,0,200.452,0h-1.035a3.814,3.814,0,0,1,3.814,3.814V9.958a1.788,1.788,0,0,0,.588,1.326l.581.526a1.788,1.788,0,0,1-1.046,3.107c-.712.064-1.809.083-2.877.087,1.335,0,2.964,0,3.912-.087a1.788,1.788,0,0,0,1.046-3.107Z",
    transform: "translate(-196.682 0)",
    fill: "#282429"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_49923",
    "data-name": "Path 49923",
    d: "M123.916,275.969c2.716,0,5.048,1.851,5.519,7.116a2.236,2.236,0,0,1-.5,1.788,1.768,1.768,0,0,1-1.3.7h-8.919a.422.422,0,0,1-.4-.438C118.311,278.293,120.873,275.969,123.916,275.969Z",
    transform: "translate(-116.99 -264.735)",
    fill: "#acd980"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49924",
    "data-name": "Path 49924",
    d: "M243.223,275.969q-.274,0-.542.026c2.8.27,5.063,2.71,5.063,9.145a.421.421,0,0,1-.4.438s.8-.077.944-.269a5.068,5.068,0,0,0,.459-2.217C248.274,277.822,245.94,275.969,243.223,275.969Z",
    transform: "translate(-236.297 -264.735)",
    fill: "#8cc951"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49925",
    "data-name": "Path 49925",
    d: "M340.409,448.467c.081.768.128,1.627.136,2.586h1.628a.421.421,0,0,0,.4-.438q0-1.16-.1-2.149Z",
    transform: "translate(-330.047 -430.211)",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49926",
    "data-name": "Path 49926",
    d: "M358.5,448.467h-1.085c.062.661.1,1.376.1,2.149a.422.422,0,0,1-.4.438h1.085a.385.385,0,0,0,.258-.1.452.452,0,0,0,.146-.337C358.6,449.9,358.567,449.158,358.5,448.467Z",
    transform: "translate(-346.066 -430.211)",
    fill: "#f2bb88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49927",
    "data-name": "Path 49927",
    d: "M118.406,448.467q-.094.991-.1,2.149a.422.422,0,0,0,.4.438h1.628c.008-.959.055-1.819.136-2.586Z",
    transform: "translate(-116.99 -430.211)",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49928",
    "data-name": "Path 49928",
    d: "M190.122,270.713a6.643,6.643,0,0,0-.361-1.322,1.928,1.928,0,0,0-1.8-1.227h-1.464a1.945,1.945,0,0,0-1.817,1.262,6.626,6.626,0,0,0-.348,1.288,1.14,1.14,0,0,0,.3,1.065,1.108,1.108,0,0,0,.8.2,4.879,4.879,0,0,0,1.6-.415.474.474,0,0,1,.392,0,4.879,4.879,0,0,0,1.6.415,1.108,1.108,0,0,0,.8-.2A1.14,1.14,0,0,0,190.122,270.713Z",
    transform: "translate(-180.298 -257.247)",
    fill: "#edf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49929",
    "data-name": "Path 49929",
    d: "M223.478,220.479v2.514a2.4,2.4,0,0,0,.188.888,1.225,1.225,0,0,0,2.271,0,2.4,2.4,0,0,0,.188-.888v-2.514Z",
    transform: "translate(-217.876 -211.504)",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49930",
    "data-name": "Path 49930",
    d: "M223.478,222.44a3.656,3.656,0,0,0,1.827.586,3,3,0,0,0,.821-.131V220.48h-2.648Z",
    transform: "translate(-217.876 -211.505)",
    fill: "#f2bb88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49931",
    "data-name": "Path 49931",
    d: "M175.373,90.333a3.589,3.589,0,1,1-7.146,0,7.441,7.441,0,0,1,.126-1.432,3.273,3.273,0,0,0,1.516-1.161.242.242,0,0,1,.342-.053,6.463,6.463,0,0,0,5.007,1.075,7.169,7.169,0,0,1,.155,1.571Z",
    transform: "translate(-164.874 -84.071)",
    fill: "#f2d1a5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28915",
    "data-name": "Group 28915",
    transform: "translate(4.916 5.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49932",
    "data-name": "Path 49932",
    d: "M210.332,147a.315.315,0,0,1-.315-.315v-.131a.315.315,0,0,1,.629,0v.131A.315.315,0,0,1,210.332,147Zm-3.391,0a.315.315,0,0,1-.315-.315v-.131a.315.315,0,1,1,.629,0v.131A.315.315,0,0,1,206.942,147Zm1.7,1.77a1.533,1.533,0,0,1-.917-.334.315.315,0,1,1,.375-.505.809.809,0,0,0,1.085,0,.315.315,0,0,1,.375.505A1.533,1.533,0,0,1,208.637,148.769Z",
    transform: "translate(-206.627 -146.239)",
    fill: "#302d31"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotherHighlighted);
export default __webpack_public_path__ + "static/media/MotherHighlighted.c36a91a8f038070e8bfa34420f4e49c4.svg";
export { ForwardRef as ReactComponent };